export default "__VITE_ASSET__QjuTFAmT__"